import MUIRadioGroup from "@mui/material/RadioGroup";

const RadioGroup = MUIRadioGroup;

export default RadioGroup;
